<template>
    <div>
        <div class="mb10">
            <span class="font14px text-bold pr20 pointer" @click="toListPage" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: this.type=='add'?'创建任务(返回)':'编辑任务(返回)'}">
                <i class="el-icon-back"></i>返回</span>|
            <span class="font14px text-bold pl20 pr20 pointer">{{this.type=='add'?'创建':'编辑'}}任务</span>
            <el-button :loading="submitLoading" :disabled="taskNameLoading" type="primary" size="mini" @click="handleSubmit" v-matomo="{behaviorCategory: '自动化报告(任务报告列表)', event: '点击',  name: this.type=='add'?'创建任务(提交)':'编辑任务(提交)'}">保存</el-button>
        </div>
        <el-form :inline="true" :model="formItem" :rules="rules" ref="form" size="mini" v-loading="dataLoading">
            <el-form-item label="任务名称：" prop="task_name" class="label-required">
                <el-input v-model.trim="formItem.task_name" placeholder="请输入任务名称" style="width:230px;" clearable />
            </el-form-item>
            <el-form-item label="自动生成时间：" prop="generate_time" class="label-required">
                <span class="text-normal mr6">每</span>
                <el-select multiple v-model="formItem.generate_frequency" @change="changeWeek" placeholder="请选择" class="mr6" style="width: 420px">
                    <el-option label="周一" value="1"></el-option>
                    <el-option label="周二" value="2"></el-option>
                    <el-option label="周三" value="3"></el-option>
                    <el-option label="周四" value="4"></el-option>
                    <el-option label="周五" value="5"></el-option>
                    <el-option label="周六" value="6"></el-option>
                    <el-option label="周日" value="7"></el-option>
                </el-select>

                <el-time-picker
                    :clearable="false"
                    style="width:150px;"
                    v-model="formItem.generate_time"
                    :picker-options="pickerOptions"
                    value-format="HH:mm"
                    format="HH:mm"
                    placeholder="选择时间">
                </el-time-picker>
            </el-form-item>
            <el-form-item label="接收配置：" class="label-required">
                <el-button type="primary" @click="showEmailModal" class="mr20" plain>配置</el-button>
                <span v-if="isConfigMail" class="font12px">邮件<span class="text-color-success">（配置完成）</span></span>
                <span v-else class="font12px">邮件<span class="text-color-error">（未配置）</span></span>
            </el-form-item>
        </el-form>
        <div class="file-data-list" v-loading="dataLoading">
            <div class="tool-bar clearfix">
                <div class="fl">
                    <el-button type="primary" @click="showFileModal">添加任务文件</el-button>
                    <el-button type="primary" @click="showDropModal" plain>调整文件排序</el-button>
                </div>
                <div class="fr">
                    <el-form :inline="true" :model="formSearch" ref="formSearch" size="mini">
                        <el-form-item label="">
                            <el-input v-model.trim="formSearch.file_name" placeholder="文件名称" style="width:160px;" clearable />
                        </el-form-item>
                        <el-form-item label="">
                            <el-input v-model.trim="formSearch.account" placeholder="账户名称、ID" style="width:160px;" clearable />
                        </el-form-item>
                        <el-form-item label="">
                            <el-input v-model.trim="formSearch.app" placeholder="产品名称、ID、包名" style="width:160px;" clearable />
                        </el-form-item>

                        <el-form-item label="">
                            <SelectAll :options="isAllowedPlatList" v-model="formSearch['plat_id']" :placeholder="'媒体'" style="width:160px;"/>
                        </el-form-item>

                        <el-form-item label="">
                            <ESelect v-model="formSearch.template" placeholder="模板名称" @visible-change="templateSelectVisibleChange" :loading="templateLoading" style="width:120px;" filterable clearable>
                                <el-option
                                    v-for="item in templateList"
                                    :key="item.template_id"
                                    :label="item.template_name"
                                    :value="item.template_id">
                                </el-option>
                            </ESelect>
                        </el-form-item>
                        <el-form-item label="">
                            <el-button type="primary" @click="searchFileList" class="mr10" plain>搜索</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <el-table
                ref="dataTable"
                :data="filterDataList"
                tooltip-effect="dark"
                :header-cell-style="{background:'#e8eaec',color:'#333'}"
                stripe
                style="width: 100%;">
                <el-table-column
                    type="index"
                    label="序号"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="daily_file_name"
                    show-overflow-tooltip
                    label="文件名称"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="account"
                    label="账户&产品"
                    min-width="100">
                    <template slot-scope="scope">
                        <el-popover width="460" trigger="hover">
                            <span slot="reference" class="text-color-primary pointer">
                                <span class="mr10" v-if="scope.row.company.length>0">账户（{{scope.row.company.length}}）</span>
                                <span class="mr10" v-if="scope.row.app.length>0">产品（{{scope.row.app.length}}）</span>
                                <span class="mr10" v-if="scope.row.customer.length>0">客户（{{scope.row.customer.length}}）</span>
                            </span>
                            <div style="max-height: 360px;overflow-y: auto;">
                                <div class="company-list" v-if="scope.row.company.length>0">
                                    <h3>账户</h3>
                                    <p v-for="item in scope.row.company||[]" :key="item.account_id" class="pl20 ellipsis" :title="item.account_name+'-'+(scope.row.plat_name=='vivo'?item.user_name:item.account_id)">{{item.account_name}}（{{scope.row.plat_name=='vivo'?item.user_name:item.account_id}}）</p>
                                </div>
                                <div class="app-list" v-if="scope.row.app.length>0">
                                    <h3>产品</h3>
                                    <p v-for="item in scope.row.app||[]" :key="item.subproject_id" class="pl20 ellipsis" :title="item.subproject_name+'-'+item.subproject_id+'-'+item.subproject_content">
                                        {{item.subproject_name}}（{{item.subproject_id}}）{{item.subproject_content ? `（${item.subproject_content}）` : ''}}
                                    </p>
                                </div>
                                <div class="customer-list" v-if="scope.row.customer.length>0">
                                    <h3>客户</h3>
                                    <p v-for="item in scope.row.customer||[]" :key="item.company_name" class="pl20 ellipsis" :title="item.company_name">{{item.company_name}}</p>
                                </div>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="plat_name"
                    label="媒体"
                    min-width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.plat_name || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="template_name"
                    label="模板"
                    min-width="100">
                </el-table-column>
                <el-table-column
                    prop="template_id"
                    label="统计周期"
                    min-width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.statistical_period=='1'">最近7天</span>
                        <span v-else-if="scope.row.statistical_period=='2'">最近30天</span>
                        <span v-else-if="scope.row.statistical_period=='3'">全部投放日期</span>
                        <span v-else-if="scope.row.statistical_period=='4'">最近{{scope.row.time_slot}}天</span>
                        <span v-else-if="scope.row.statistical_period=='5'">开始日期{{scope.row.time_slot_date}}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    prop="action"
                    label="操作"
                    align="center"
                    min-width="100">
                    <template slot-scope="scope">
                        <span class="text-color-primary pointer pl6 pr6" @click="editFile(scope.row)">编辑</span>
                        <span class="text-color-error pointer pl6 pr6" @click="removeFile(scope.row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="page-bar tac mt20">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryData.pn"
                :page-sizes="[30,50,100]"
                :page-size="queryData.rn"
                :pager-count="5"
                layout="total, sizes, prev, pager, next, jumper"
                :total="queryData.total">
            </el-pagination>
        </div>

        <MailConfigModal ref="mailConfigModal" :data="mailItem" @save="saveMailConfig"/>
        <TaskFileModal ref="taskFileModal" :data="actionFileData" :task-type="type" :type="actionFileType" :page-func-names="pageFuncNames" :allowed-plat-list="allowedPlatList" @submit="submitFileData"/>
        <DropModal ref="dropModal" :list="filterDataList" @save="saveDropData" />
    </div>
</template>

<script>
    import API from '@/api/efficiencyTool/task.js';
    import TaskFileModal from './modal/taskFileModal';
    import SelectAll from '@/components/SelectAll';
    import MailConfigModal from './modal/mailConfigModal';
    import DropModal from './modal/dropModal.vue';
    import utils from '@/libs/utils.js';
    import {cloneDeep} from 'lodash'
    export default {
        name: "CreatePage",
        components:{
            TaskFileModal,
            MailConfigModal,
            DropModal,
            SelectAll
        },
        props:{
            allowedPlatList:Array,
            data:Object,
            type:String,
            pageFuncNames:Array,
        },
        data(){
            let _this = this;
            const task_name = (rule, value, callback) => {
                if(!value){
                    callback(new Error('任务名称不能为空'));
                }else if(value.length >40){
                    return callback(new Error('任务名称不可超过40个字'));
                }else{
                    // _this.taskNameLoading=true;
                    // API.checkTaskName({
                    //     task_name:value,
                    //     task_id:_this.data.task_id||'',
                    // }).then(()=>{
                    //     callback();
                    //     _this.taskNameLoading=false;
                    // },err=>{
                    //     callback(new Error(err.info||'任务名称不能重复'));
                    //     _this.taskNameLoading=false;
                    // })
                    callback();
                }
            };
            const generate_time = (rule, value, callback) => {
                if(!_this.formItem.generate_time){
                    callback(new Error('生成时间不能为空'));
                }else if(_this.formItem.generate_frequency.length<=0){
                    callback(new Error('请选择生成周期'));
                }else{
                    callback();
                }
            };
            return {
                taskNameLoading:false,
                submitLoading:false,
                dataLoading:false,
                formItem:{
                    task_name:'',
                    generate_time:'09:00',
                    generate_frequency:[],
                },
                mailItem:{
                    direction_email:'',
                    email:'',
                    body:'',
                    zip_send:'',
                    is_send:'',
                    send_type:'',
                    title_date:'1',
                },
                formSearch:{
                    file_name:'',
                    account:'',
                    app:'',
                    template:'',
                    plat_id:''
                },
                isConfigMail:false,
                pickerOptions:{
                    format:'HH:mm',
                    // selectableRange: '10:00:00 - 23:59:59',

                },
                rules:{
                    task_name:[
                        { validator:task_name, trigger: 'blur' }
                    ],
                    generate_time:[
                        // { required: true, message: '请选择自动生成时间', trigger: 'change' },
                        { validator:generate_time, trigger: ['blur','change'] }
                    ],
                },
                queryData:{
                    pn:1,
                    rn:30,
                    total:0,
                },
                filterDataList:[],
                dataList:[],
                pageDataList:[],
                actionFileData:{},
                actionFileType:'',
                templateList:[],
                templateLoading:false,
            }
        },
        computed:{
            // filterDataList(){
            //     if(!this.formSearch.file_name&&!this.formSearch.account&&!this.formSearch.app&&!this.formSearch.template&&!this.formSearch.plat_id){
            //         return this.dataList;
            //     }

            //     let sliceDataList = this.dataList.slice((this.queryData.pn - 1) * this.queryData.rn, this.queryData.pn * this.queryData.rn)
            //     console.log('sliceDataList',this.dataList, sliceDataList)
            //     return sliceDataList && sliceDataList.filter(item=>{
            //         if(!this.formSearch.file_name) return true;
            //         return item.daily_file_name.includes(this.formSearch.file_name);
            //     }).filter(item=>{
            //         if(!this.formSearch.account) return true;
            //         let companyList = item.company||[];
            //         return companyList.some(inner=>inner.account_id.includes(this.formSearch.account)||inner.account_name.includes(this.formSearch.account));
            //     }).filter(item=>{
            //         if(!this.formSearch.app) return true;
            //         let appList = item.app||[];
            //         return appList.some(inner=>inner.subitem_id.includes(this.formSearch.app)||inner.subproject_name.includes(this.formSearch.app)||inner.subproject_content.includes(this.formSearch.app));
            //     }).filter(item=>{
            //         if(!this.formSearch.template) return true;
            //         return this.formSearch.template?item.template_id== this.formSearch.template:true;
            //     }).filter(item=>{
            //         if(!this.formSearch.plat_id) return true;
            //         let platNameList = this.allowedPlatList.filter(ele=> this.formSearch.plat_id.includes(ele.id)).map(v=>v.name.toLowerCase())
            //         return platNameList.includes(item.plat_name.toLowerCase())
            //     });
            // },
            isAllowedPlatList() {
                return this.allowedPlatList;
            }
        },
        watch:{
            'formSearch': {
                handler() {
                    this.getList()
                },  
                deep: true
            },
            'dataList.length': {
                handler() {
                    this.getList()
                },
            }
        },
        mounted(){
            this.getTemplateList();
            if(this.type=='add'){
                this.formItem.generate_frequency = ['1','2','3','4','5','6','7'];
            }
        },
        methods:{
            getList() {
                if(!this.formSearch.file_name&& !this.formSearch.account && !this.formSearch.app&&!this.formSearch.template && (!this.formSearch.plat_id || this.formSearch.plat_id.length ===0)){
                        this.pageDataList = cloneDeep(this.dataList)
                        this.queryData.total = this.dataList.length;
                        this.handleCurrentChange(1)
                        
                        return 
                    }

                    let sliceDataList = cloneDeep(this.dataList)
                    let result = sliceDataList && sliceDataList.filter(item=>{
                        if(!this.formSearch.file_name) return true;
                        return item.daily_file_name.includes(this.formSearch.file_name);
                    }).filter(item=>{
                        if(!this.formSearch.account) return true;
                        let companyList = item.company||[];
                        return companyList.some(inner=>inner.account_id.includes(this.formSearch.account)||inner.account_name.includes(this.formSearch.account));
                    }).filter(item=>{
                        if(!this.formSearch.app) return true;
                        let appList = item.app||[];
                        return appList.some(inner=>inner.subitem_id.includes(this.formSearch.app)|| inner.subproject_id.includes(this.formSearch.app) ||inner.subproject_name.includes(this.formSearch.app)||inner.subproject_content.includes(this.formSearch.app));
                    }).filter(item=>{
                        if(!this.formSearch.template) return true;
                        return this.formSearch.template?item.template_id== this.formSearch.template:true;
                    }).filter(item=>{
                        if(!this.formSearch.plat_id?.length) return true;
                        let platNameList = this.allowedPlatList.filter(ele=> this.formSearch.plat_id.includes(ele.id)).map(v=>v.name.toLowerCase())
                        return platNameList.includes(item.plat_name.toLowerCase())
                    })
                    this.pageDataList = result;
                    this.queryData.total = result.length;
                    this.handleCurrentChange(1)
            },
            toListPage(){
                this.$emit('back');
            },
            setData(){
                this.getTaskInfo();
            },
            getTemplateList(){
                /* 获取模板下拉列表*/
                this.templateLoading = true;
                API.getSearchTemplateList().then(res=>{
                    this.templateList = res.data||[];
                    this.templateLoading = false;
                },err=>{
                    this.templateList = [];
                    this.templateLoading = false;
                });
            },
            getTaskInfo(){
                let taskId = this.data.task_id;
                this.dataLoading = true;
                API.getTaskInfo({
                    task_id:taskId,
                }).then(res=>{
                    this.dataLoading = false;
                    let resData = res.data||{};

                    this.formItem.task_name = resData.task_name;
                    this.formItem.generate_time = resData.generate_time_format;
                    this.formItem.generate_frequency = (resData.generate_frequency||"").split('');

                    this.mailItem.direction_email = resData.direction_email.replace(/\;/g,",");
                    this.mailItem.email = resData.email.replace(/\;/g,",");
                    this.mailItem.body = resData.body;
                    this.mailItem.zip_send = resData.zip_send;
                    this.mailItem.is_send = resData.is_send;
                    this.mailItem.send_type = resData.send_type;
                    this.mailItem.title_date = resData.title_date;
                    this.mailItem.title = resData.title;
                    this.isConfigMail = true;


                    this.dataList = (resData.daily_list||[]).map(item=>{
                        return {
                            ...item,
                            task_detail_id:item.task_detail_id,
                            plat_id:item.plat_id,
                            plat_name:item.plat_name,
                            template_id:item.template_id,
                            template_name:item.template_name,
                            selectAPPType:item.select_type||'1',
                            daily_file_name:item.daily_file_name,
                            file_date:item.file_date,
                            time_slot:item.statistical_period=='4'?item.time_slot:'',
                            statistical_period:item.statistical_period,
                            time_slot_date:item.statistical_period=='5'?item.time_slot:'',
                            company:item.account_info||[],
                            app:item.app_info||[],
                            customer:item.customer_info||[],
                        };
                    });
                    this.handleCurrentChange(1)

                },err=>{
                    this.dataLoading = false;
                })
            },
            changeWeek(val){
                console.log('changeWeek',val);
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if(!this.isConfigMail) return this.$message.error('接收邮件未配置');
                        if(this.dataList.length<=0) return this.$message.error('请先添加任务文件');

                        let taskId = this.type=='edit'?this.data.task_id||'':'';

                        let reqData = {
                            id:taskId,
                            task_name:this.formItem.task_name,
                            generate_time:this.formItem.generate_time,
                            generate_frequency:this.formItem.generate_frequency.join(''),

                            /*邮件信息*/
                            title_date:this.mailItem.title_date,
                            title:this.mailItem.title,
                            direction_email:this.mailItem.direction_email.replace(/\;/g,","),
                            email:this.mailItem.email.replace(/\;/g,","),
                            zip_send:this.mailItem.zip_send,
                            is_send:this.mailItem.is_send,
                            send_type:this.mailItem.send_type,
                            body:this.mailItem.body,
                        };

                        let detailData = this.dataList.map(item=>{
                            /* 处理[统计周期]的值 */
                            let timeSlotVal = '';
                            if(item.statistical_period=='4'){
                                timeSlotVal = item.time_slot;
                            }else if(item.statistical_period=='5'){
                                timeSlotVal = item.time_slot_date;
                            }


                            //判断是否是前端自己添加的detailId
                            let isRandom = (item.task_detail_id||'').includes('random-');
                            return {
                                plat_id:item.plat_id,
                                plat_name:item.plat_name,
                                template_id:item.template_id,
                                template_name:item.template_name,
                                selectAPPType:item.selectAPPType,
                                daily_file_name:item.daily_file_name,
                                file_date:item.file_date,
                                statistical_period:item.statistical_period,
                                time_slot:timeSlotVal,
                                time_zone:item.plat_id=='9'?item.time_zone:'',
                                app:item.app,
                                company:item.company,
                                customer:item.customer,
                                detail_id:isRandom?'':item.task_detail_id,
                            }
                        });

                        reqData.detail = JSON.stringify(detailData);

                        this.submitLoading = true;
                        API.saveDailyTask(reqData).then(res=>{

                            this.submitLoading = false;
                            this.$message.success(res.info||'');

                            this.toListPage();
                            this.$emit('update');
                        },err=>{
                            this.submitLoading = false;

                            let errData = err.data||[];
                            if(err.code==0&&errData.length>0){
                                this.$notify.error({
                                    title: err.info||'请求失败',
                                    dangerouslyUseHTMLString: true,
                                    message: "<div>"+errData.map(item=>`<p class="font12px">${item.errorMsg}；</p>`).join('')+"</div>",
                                    duration: 0
                                });
                            }else{
                                this.$message.error(err.info||'操作失败');
                            }
                        });
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            showEmailModal(){
                this.$refs.mailConfigModal.showModal();
            },
            showFileModal(){
                this.actionFileData = {};
                this.actionFileType = 'add';
                this.$refs.taskFileModal.showModal();
            },
            showDropModal() {
                if(!this.filterDataList.length) {
                    return this.$message.error('请先添加任务文件');
                }
                this.$refs.dropModal.showModal();
            },
            templateSelectVisibleChange(val){
                if(val){
                    this.getTemplateList();
                }
            },
            searchFileList(){
                console.log('searchFileList');
            },
            saveMailConfig(data){
                this.isConfigMail = true;
                this.mailItem.direction_email = data.direction_email.replace(/\;/g,",");
                this.mailItem.email = data.email.replace(/\;/g,",");
                this.mailItem.title = data.title;
                this.mailItem.body = data.body;
                this.mailItem.zip_send = data.zip_send;
                this.mailItem.is_send = data.is_send;
                this.mailItem.send_type = data.send_type;
                this.mailItem.title_date = data.title_date;
            },
            submitFileData(type,data){
                if(type == 'add'){
                    data.task_detail_id= 'random-'+utils.randomString(16);
                    console.log('add',data);
                    this.dataList.push(data);
                    this.queryData.total = this.dataList.length;
                    
                }else if(type=='edit'){
                    let actionItem = this.dataList.find(item=>item.task_detail_id==data.task_detail_id);
                    if(actionItem){
                        actionItem.task_detail_id = data.task_detail_id;
                        actionItem.plat_id = data.plat_id;
                        actionItem.template_id = data.template_id;
                        actionItem.template_name = data.template_name;
                        actionItem.selectAPPType = data.selectAPPType;
                        actionItem.time_zone = data.time_zone;
                        actionItem.daily_file_name = data.daily_file_name;
                        actionItem.statistical_period = data.statistical_period;
                        actionItem.time_slot = data.time_slot;
                        actionItem.time_slot_date = data.time_slot_date;
                        actionItem.app = [...data.app];
                        actionItem.company = [...data.company];
                        actionItem.customer = [...data.customer];
                        actionItem.file_date = data.file_date;
                        this.getList();
                    }else{
                        console.log('数据有误');
                    }
                }
            },
            editFile(row){
                this.actionFileType = 'edit';
                this.actionFileData = utils.deepClone(row);
                this.$refs.taskFileModal.showModal();
            },
            removeFile(row){
                this.$alert('您确定要删除文件：<span class="text-bold">'+row.daily_file_name+'</span> 吗？', {
                    type:'error',
                    confirmButtonText:'确认删除',
                    confirmButtonClass:'danger-button',
                    showCancelButton:true,
                    dangerouslyUseHTMLString:true,
                }).then(()=>{
                    let index = this.dataList.findIndex(item=>item.task_detail_id==row.task_detail_id);
                    this.dataList.splice(index,1);
                }).catch(()=>{
                    console.log('取消删除');
                });
            },
            saveDropData(params) {
                let deepParams = cloneDeep(params);
                let result = this.dataList.map(item=>{
                    if(deepParams.some(inner=>inner.task_detail_id==item.task_detail_id)) {
                        return 'seat'
                    }else{
                        return item
                    }
                }).map(v=>{
                    if(v==='seat'){
                        let splice_item = deepParams.splice(0,1)
                        return splice_item && splice_item.length != 0 ?  splice_item[0] : {}
                    }
                    return v
                })
                this.dataList = result
                // this.handleCurrentChange(1)
                this.getList()
            },
            handleSizeChange(current){
                this.queryData.rn = current
                this.handleCurrentChange(1)
            },
            handleCurrentChange(current){
                this.queryData.pn = current
                let result = this.pageDataList.slice((this.queryData.pn - 1) * this.queryData.rn, this.queryData.pn * this.queryData.rn)
                this.filterDataList = result
            },
        },
    }
</script>

<style lang="scss" scoped>

    .file-data-list {
        padding: 10px;
        border: solid 1px #dcdee2;
        min-height: 300px;
    }
</style>
